module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.actionTime || _vm.data.showImage === 'SHOW') ? _c('div', {
    staticClass: "client-item-box new-time-box",
    attrs: {
      "id": 'nofixNav' + _vm.data.nofixNavId + '-' + _vm.data.nofixNavIndex,
      "data-trackdata": _vm.tData
    }
  }, [_c('beast-image', {
    staticClass: "time-image",
    attrs: {
      "image": _vm.data.bgImage,
      "lazy": true,
      "containerWidth": _vm.containerWidth
    }
  }), _vm._v(" "), (_vm.actionTime) ? _c('div', {
    staticClass: "time",
    style: (_vm.renderPositionStyl)
  }, [_c('span', {
    staticClass: "title-block mr",
    style: (_vm.renderTitleStyl)
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._l((_vm.actionTime.day), function(item) {
    return (_vm.actionTime.day != '0') ? _c('span', {
      staticClass: "time-block",
      style: (_vm.renderTimeStyl)
    }, [_vm._v(_vm._s(item))]) : _vm._e()
  }), _vm._v(" "), (_vm.actionTime.day.length && _vm.actionTime.day != '0') ? _c('span', {
    staticClass: "title-block mr ml",
    style: ({
      color: _vm.data.titleColor
    })
  }, [_vm._v("天")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.actionTime.hour), function(item, index) {
    return _c('span', {
      staticClass: "time-block",
      class: {
        'two': index === 1
      },
      style: (_vm.renderTimeStyl)
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('span', {
    staticClass: "title-block mr ml",
    style: (_vm.renderTitleStyl)
  }, [_vm._v("时")]), _vm._v(" "), _vm._l((_vm.actionTime.minute), function(item, index) {
    return _c('span', {
      staticClass: "time-block",
      class: {
        'two': index === 1
      },
      style: (_vm.renderTimeStyl)
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('span', {
    staticClass: "title-block mr ml",
    style: (_vm.renderTitleStyl)
  }, [_vm._v("分")]), _vm._v(" "), _vm._l((_vm.actionTime.second), function(item, index) {
    return _c('span', {
      staticClass: "time-block",
      class: {
        'two': index === 1
      },
      style: (_vm.renderTimeStyl)
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('span', {
    staticClass: "title-block ml",
    style: (_vm.renderTitleStyl)
  }, [_vm._v("秒")])], 2) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cf4b0a9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/renderer-config/components/new-time.vue
// module id = 660
// module chunks = 1 13